import { Action, Reducer } from "redux";
import {
	IntegrationTriggerState,
	IntegrationTriggerTypes,
	IntegrationTriggerActionTypes,
} from "./integrationTriggerTypes";

export const INITIAL_STATE: IntegrationTriggerState = {
	integrationTriggers: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const integrationTriggerReducer: Reducer<IntegrationTriggerState> = (
	state: IntegrationTriggerState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as IntegrationTriggerActionTypes;
	switch (actionTypes.type) {
		case IntegrationTriggerTypes.GET_INTEGRATION_TRIGGER:
			return {
				...state,
				integrationTriggers: { ...state.integrationTriggers, isLoading: true },
			};
		case IntegrationTriggerTypes.SAVE_INTEGRATION_TRIGGER:
			return {
				...state,
				integrationTriggers: {
					...state.integrationTriggers,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTriggerTypes.RESET_INTEGRATION_TRIGGER:
			return {
				...state,
				integrationTriggers: INITIAL_STATE.integrationTriggers,
			};
		default:
			return state;
	}
};

export default integrationTriggerReducer;
